$(document).on("keypress", "input[type=text], input[type=number], select, button, a", function(e) {

    if ($(this).attr("data-tab") === "false") {
        return; // Não execute a função se o atributo for "false"
    }

    if (e.keyCode == 13) {

        var submitForm = $(this).hasClass('es');

        if(submitForm) {
            var form = $(this).closest("form");
            return form.submit();
        }

        var tag = (this.tagName || '').toLowerCase();
        var type = $(this).attr('type');

        if(type == 'button' || type == 'submit') {
            $(this).trigger('click');
            return false;
        }

        if(tag == 'a') {
            $(this)[0].click();
            return false;
        }

        var inps = $("input, select, button, a");
        for (var x = 0; x < inps.length; x++) {
            if (inps[x] == this) {
                // Evite erro quando este elemento for o último (inps[x + 1] indefinido)
                while (
                    (x + 1) < inps.length &&
                    inps[x] &&
                    inps[x + 1] &&
                    inps[x].name &&
                    inps[x + 1].name &&
                    (inps[x]).name == (inps[x + 1]).name
                ) {
                    x++;
                }
                if ((x + 1) < inps.length) {
                    $(inps[x + 1]).focus();
                }
            }
        }
        e.preventDefault();
    }
});
